module.exports = __webpack_public_path__ + "img/50.bf4ef1c8.svg";